import { permissionObj } from "../../../../../Helpers/permission"
import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE} from "../../../../../Apis/functions";
import {VIEW_TYPE} from "../../../../../enums/ViewType";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
export const NO_DEPARTMENT = "NO_DEPARTMENT";
export const SUFFIX_COLOR_TEXT = "Txt";
//Tabs to show
export const TABS_ATTENDANCE = {
    ATTENDANCE: {
        INDEX: 0,
        TRANS: "attendance"
    },

    SUBMISSIONS: {
        INDEX: 2,
        TRANS: "submissions"
    },

    MANAGE: {
        INDEX: 1,
        TRANS: "manage"
    },
};

export const ATTENDANCE_SUBVIEW_MODEL = {
    ATTENDANCE: {
        ATTENDANCE : 'attendance',
        MAP : 'map'
    },
    MANAGE: {
        SHIFT_ACCESS:"SHIFT_ACCESS",
        SETTINGS: "SETTINGS",
        DEPARTMENT_POLICIES:"DEPARTMENT_POLICIES",
        GEOFENCE: "GEOFENCE"
    },
    SUBMISSIONS: {
        PERIOD_REVIEW:"PERIOD_REVIEW",
        REQUEST: "REQUEST",
        HISTORY:"HISTORY",
    }
}

const CREATE_PERMISSION_SUB_VIEW = {
    [ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS]: permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE,
    [ATTENDANCE_SUBVIEW_MODEL.MANAGE.GEOFENCE]: permissionObj?.WEB_ATTENDANCE_CREATE,
};

export function TAB_PERMISSION_ATTENDANCE(subView , view) {
    return {
        CREATE: {
            [TABS_ATTENDANCE.MANAGE.INDEX]: CREATE_PERMISSION_SUB_VIEW[subView] || undefined
        },
        UPDATE: {
            [TABS_ATTENDANCE.MANAGE.INDEX]: subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.SETTINGS ? permissionObj?.WEB_ATTENDANCE_SETTING_UPDATE: undefined
        },
        DELETE: {
            [TABS_ATTENDANCE.MANAGE.INDEX]: subView === ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS? permissionObj?.WEB_ATTENDANCE_SHIFT_DELETE : undefined
        },
        EXPORT : {
            [TABS_ATTENDANCE.ATTENDANCE.INDEX] : view === VIEW_TYPE.LIST.name ? permissionObj?.WEB_ATTENDANCE_EXPORT : ''
        },
        ADVANCE_SEARCH : {
            [TABS_ATTENDANCE.ATTENDANCE.INDEX]: view === VIEW_TYPE.LIST.name ? permissionObj?.WEB_ATTENDANCE_READ : ''
        }
    }
}


export const MODEL_CONTEXT_ATTENDANCE = {
    tabIndex: null,
    disabledBtnDelete: true,
    modalCreate: false,
    modalDelete: false,
}


export const ATTENDANCE_MODEL ={
    departmentId :null ,
    userId :null ,
    latitude : DEFAULT_LATITUDE,
    longitude : DEFAULT_LONGITUDE,
    startDate: null,
    endDate: null,
}

export const SUB_VIEW_MODEL = {
    ATTENDANCE: {
        ATTENDANCE : 'attendance',
        MAP : 'map'
    },
    MANAGE :{
        MANAGE : 'manage'
    }
};

const getColorCss = (variableName) => {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(variableName)
        .trim();
};

export const ATTENDANCE_COLOR_MODEL = {
    id:null,
    inTime: "",
    inTimeTxt: "",
    toleranceTime: "",
    toleranceTimeTxt: "",
    afterHours: "",
    afterHoursTxt: "",
    absent: "",
    absentTxt: "",
    noDepartment: "",
    noDepartmentTxt: "",
    specialPermission: "",
    specialPermissionTxt: "",
    offScheduleDeparture: "",
    offScheduleDepartureTxt: "",
    offScheduleArrival: "",
    offScheduleArrivalTxt: "",
    onVacations: "",
    onVacationsTxt: "",
    type : "ATTENDANCE_COLOR_MODEL",
    setDefaultData: function (){
        return {
            ...this,
            inTime: getColorCss("--in-time-color"),
            inTimeTxt: getColorCss("--in-time-text-color"),
            toleranceTime: getColorCss("--tolerance-time-color"),
            toleranceTimeTxt: getColorCss("--tolerance-time-text-color"),
            afterHours: getColorCss("--after-hours-color"),
            afterHoursTxt: getColorCss("--after-hours-text-color"),
            absent: getColorCss("--absent-color"),
            absentTxt: getColorCss("--absent-text-color"),
            noDepartment: getColorCss("--no-department-color"),
            noDepartmentTxt: getColorCss("--no-department-text-color"),
            specialPermission: getColorCss("--special-permission-color"),
            specialPermissionTxt: getColorCss("--special-permission-text-color"),
            offScheduleDeparture: getColorCss("--off-schedule-departure-color"),
            offScheduleDepartureTxt: getColorCss("--off-schedule-departure-text-color"),
            offScheduleArrival: getColorCss("--off-schedule-arrival-color"),
            offScheduleArrivalTxt: getColorCss("--off-schedule-arrival-text-color"),
            onVacations: getColorCss("--vacations-color"),
            onVacationsTxt: getColorCss("--vacations-text-color"),
        }
    },
    setData: function (item){
        return {
            ...this,
            ...item
        }
    },
    toRegister() {
        const { setData, toRegister, ...data } = this;
        return data;
    }
}

export const TYPE_MODEL_COLOR_MODEL = {
    BG_COLOR:"bg",
    TXT_COLOR:"txt"
}

export const ATTENDANCE_STATUS_COLOR_MODEL = {
    0: 'absent',
    1: 'inTime',
    2: 'offScheduleDeparture',
    3: 'afterHours',
    4: 'toleranceTime',
    5: 'noDepartment',
    6: 'specialPermission',
    7: 'offScheduleArrival',
    8: 'onVacations'
}

export const DEPARTMENT_POLICY_MODEL = {
    id: null,
    departmentId: null,
    supervisor: [],
    startShiftAt: '',
    endShiftAt: '',
    range: null,
    checkoutExtensionDays: null,
    isValid: function () {
        const hasTimes = this.startShiftAt !== '' && this.endShiftAt !== '';
        const differentTimes = this.startShiftAt !== this.endShiftAt;
        return hasTimes && differentTimes && this.range > 0;
    },
    normalizeValue: function (name, value) {
        if (name === 'range') {
            const numericValue = Number(value);
            return value === '' || numericValue === 0 ? null : numericValue;
        }
        return value;
    },
    toAddEdit: function (supervisorIds) {
        return {
            id: this.id,
            startShiftAt: this.startShiftAt,
            endShiftAt: this.endShiftAt,
            range: this.range,
            departmentId: this.departmentId,
            supervisor: supervisorIds,
            checkoutExtensionDays: this.checkoutExtensionDays,
        };
    },
   clear: function () {
    this.id = null;
    this.departmentId = null;
    this.supervisor = [];
    this.startShiftAt = '';
    this.endShiftAt = '';
    this.range = null;
    this.checkoutExtensionDays = null;
},

};
